import React from 'react';
import { UnitListFragment } from '../../../generated/graphql';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box } from '@mui/material';

interface SelectUnitDialogProps {
  units: UnitListFragment[];
  selected: UnitListFragment[];
  onSubmit: (unitId: string) => void;
  onClose: () => void;
}

export function SelectUnitDialog(props: SelectUnitDialogProps) {
  const { units, selected, onSubmit, onClose } = props;
  const [searchQuery, setSearchQuery] = React.useState('');

  // Filter out already selected units, 'not_renting' status units, and sort ascending by name
  const availableUnits = units
    .filter((p) => selected.findIndex((s) => s.id === p.id) < 0)
    .filter((p) => p.status !== 'not_renting') // Exclude 'not_renting' units from contract selection
    .sort((a, b) => a.name.localeCompare(b.name));

  // Filter by search query
  const filteredUnits = availableUnits.filter((p) => p.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <Dialog
      open
      sx={{ minWidth: 350, height: { xs: '100%', sm: 'auto' }, width: { xs: '100%', sm: 'auto' } }}
      onClose={onClose}
    >
      <DialogTitle>Vyber nehnuteľnosť</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            placeholder="Hľadať nehnuteľnosť..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            autoFocus
          />
        </Box>
        <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
          {filteredUnits.map((p) => (
            <Button key={p.id} onClick={() => onSubmit(p.id)} fullWidth variant="text">
              {p.name}
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Zatvoriť</Button>
      </DialogActions>
    </Dialog>
  );
}
